import { useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core';
import { MDSIcon, MDSTypography } from '@marqvision/mds-v2';
import { Detail } from './Detail';
import { List } from './List';

const useStyles = makeStyles(({ color }) => ({
  wrapper: {
    width: '620px',
    height: '100%',
    display: 'grid',
    gridTemplateRows: 'auto 1fr',
    overflow: 'hidden',
    transition: '0.3s',
  },
  scroll: {
    overflowY: 'auto',
  },
  header: {
    padding: '16px 20px',
    display: 'flex',
    justifyContent: 'space-between',
    gap: '8px',
    borderBottom: `1px solid ${color.border.neutral.default.normal}`,
  },
  button: {
    padding: '0',
    border: 'none',
    backgroundColor: 'transparent',
    cursor: 'pointer',
  },
}));

type Props = {
  selectedId?: number;
  onSelect: (id?: number) => void;
  onClose: () => void;
};

export const ReleaseNote = (props: Props) => {
  const { selectedId, onSelect, onClose } = props;
  const classes = useStyles();

  const wrapperRef = useRef<HTMLDivElement>(null);
  const onCloseRef = useRef(onClose);

  const handleBack = () => {
    onSelect(undefined);
  };

  const handleSelect = (id: number) => {
    onSelect(id);
  };

  useEffect(() => {
    const handleBodyClick = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      if (wrapperRef.current?.contains(target)) return;
      onCloseRef.current?.();
    };
    document.body.addEventListener('click', handleBodyClick, { capture: true });
    return () => {
      document.body.removeEventListener('click', handleBodyClick, { capture: true });
    };
  }, []);

  return (
    <div ref={wrapperRef} className={classes.wrapper}>
      <div className={classes.header}>
        {selectedId ? (
          <button className={classes.button} onClick={handleBack}>
            <MDSIcon.TailArrowLeft />
          </button>
        ) : (
          <MDSTypography variant="title" size="xl" weight="semibold">
            What’s new
          </MDSTypography>
        )}
        <button className={classes.button} onClick={onClose}>
          <MDSIcon.CloseDelete variant="outline" />
        </button>
      </div>
      <div className={classes.scroll}>
        {selectedId ? <Detail selectedId={selectedId} /> : <List onClick={handleSelect} />}
      </div>
    </div>
  );
};
